import { render, staticRenderFns } from "./EndorsementRefundScenarioAlert.vue?vue&type=template&id=dc52d2b2&scoped=true"
import script from "./EndorsementRefundScenarioAlert.vue?vue&type=script&lang=js"
export * from "./EndorsementRefundScenarioAlert.vue?vue&type=script&lang=js"
import style0 from "./EndorsementRefundScenarioAlert.vue?vue&type=style&index=0&id=dc52d2b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc52d2b2",
  null
  
)

export default component.exports